import pdf from 'common/assets/nuevoInforme-1.jpg'
import pdf_2 from 'common/assets/nuevoInforme-2.jpg'
import { renderDate } from 'common/services/util';

/**
 * -------------------------
 *   CÓMO AJUSTAR LA MAQUETACIÓN
 * -------------------------
 *
 * Solo toca el objeto:
 *
 *    const L = { ... }
 *
 * Ejemplos:
 *    - Para bajar “Datos del equipo”: modificar `equipoTitleY` y `equipoHeaderY`.
 *    - Para mover los totales inferiores: tocar `subtotalY`, `ivaY`, `totalY`.
 *    - Para subir/bajar la zona de avería: `averiaTitleY` y `symptomLabelY`.
 * ===============================================================
 */

const createPDFSignUseCase = async (doc, data, clientData, detailData = {}, type, sign1, sign2, appSettings) => {
    const w = doc.internal.pageSize.getWidth();
    const h = doc.internal.pageSize.getHeight();

    const L = {
        titleY: 0.089,
        refY: 0.117,

        areaTitleY: 0.1675,
        areaDataStartY: 0.18,

        clientStartY: 0.18,

        fechaLabelY: 0.27,
        fechaValueY: 0.2825,

        equipoTitleY: 0.325,
        equipoHeaderY: 0.355,

        averiaTitleY: 0.435,
        symptomLabelY: 0.465,

        reparacionTitleY: 0.51,
        reparacionHeaderY: 0.538,

        desgloseTitleY: 0.625,
        importeTextoY: 0.6815,
        tablaHeaderY: 0.722,

        subtotalY: 0.818,
        ivaY: 0.843,
        totalY: 0.870,

        footerBlock1Y: 0.907,
        footerBlock2Y: 0.938,
        footerBlock3Y: 0.95,
        footerWidth: 0.57,

        paginationX: 0.913,
        paginationY: 0.910,

        signatureBoxX: 0.655,
        signatureBoxY: 0.898,
        signatureTextOffsetX: 0,

        photosRow1Y: 0.15,
        photosRow2Y: 0.52,
    };

    // --- Helpers ---
    const textRel = (txt, rx, ry, opts = {}) => {
        doc.text(txt, w * rx, h * ry, opts);
    };

    const safe = v => (v == null ? '' : String(v));

    const drawFooter = (doc, w, h, appSettings) => {
        const text = appSettings?.reportFooter;
        if (!text) return;

        // Caja fija del footer
        const boxWidth = w * 0.90;
        const boxHeight = 3;
        const x = w * 0.0475;
        const y = h * 0.99;

        // Color gris
        doc.setTextColor(120, 120, 120);

        // Intentamos ajustar el texto en la caja reduciendo tamaño automáticamente
        let fontSize = 3.2;      // tamaño máximo
        let lines = [];

        while (fontSize > 1.2) { // tamaño mínimo
            doc.setFontSize(fontSize);

            // Crea líneas con el tamaño actual
            lines = doc.splitTextToSize(text, boxWidth);

            // Calcula la altura total del texto
            const lineHeight = fontSize * 0.55;   // altura por línea
            const totalHeight = lines.length * lineHeight;

            if (totalHeight <= boxHeight) break;

            fontSize -= 0.1;  // si no cabe → reduce
        }

        // Pintar texto justificado dentro de la caja
        let lineHeight = fontSize * 0.55;
        let startY = y - (lines.length * lineHeight);

        lines.forEach((line, i) => {
            doc.text(line, x, startY + i * lineHeight, {
                maxWidth: boxWidth,
                align: "justify"
            });
        });

        // restaurar color negro para el resto del documento
        doc.setTextColor(0, 0, 0);
    };

    const addPagination = (doc) => {
        const pageCount = doc.internal.getNumberOfPages();
        const w = doc.internal.pageSize.getWidth();
        const h = doc.internal.pageSize.getHeight();

        doc.setFontSize(2.5);
        doc.setTextColor(100);

        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.text(
                `Página ${i} de ${pageCount}`,
                w * L.paginationX,
                h * L.paginationY,
                { align: "center" }
            );
        }

        // restaurar color negro
        doc.setTextColor(0, 0, 0);
    };

    // --- Fondo plantilla ---
    const bg = new Image();
    bg.src = pdf;
    doc.addImage(bg, 'PNG', 0, 0, w, h, '', 'FAST');

    // ==============================
    //  LOGO DE LA EMPRESA (Funcionando pero lo dejo comentado hasta que editemos el png de background)
    // ==============================
    // if (appSettings?.logoUrl) {
    //     try {
    //         const logo = new Image();
    //         logo.crossOrigin = "Anonymous";
    //         logo.src = appSettings.logoUrl;

    //         await new Promise(resolve => { logo.onload = resolve });

    //         // --- Caja fija donde irá el logo ---
    //         const boxWidth = 14;   // mm
    //         const boxHeight = 6;  // mm

    //         // --- Tamaño real del logo en px ---
    //         const imgW = logo.width;
    //         const imgH = logo.height;

    //         // --- Convertir px → mm ---
    //         const pxToMm = px => px * 0.264583;
    //         const imgWmm = pxToMm(imgW);
    //         const imgHmm = pxToMm(imgH);

    //         // --- Calcular escala proporcional ---
    //         const scale = Math.min(boxWidth / imgWmm, boxHeight / imgHmm);

    //         // --- Ajustar tamaño proporcional ---
    //         const finalW = imgWmm * scale;
    //         const finalH = imgHmm * scale;

    //         // --- Posición (arriba derecha, centrado dentro de la caja) ---
    //         const xLogo = (w * 0.0475) + (boxWidth - finalW) / 2;
    //         const yLogo = (h * 0.015) + (boxHeight - finalH) / 2;

    //         doc.addImage(
    //             logo,
    //             "PNG",
    //             xLogo,
    //             yLogo,
    //             finalW,
    //             finalH,
    //             '',
    //             'FAST'
    //         );

    //     } catch (e) {
    //         console.error("Error cargando logo en PDF:", e);
    //     }
    // }

    // =====================================================
    // CABECERA
    // =====================================================

    // "Informe de reparación"
    doc.setFontSize(4);
    doc.setFontStyle('normal');
    textRel('Informe de reparación', 0.0475, L.titleY);

    // Nº de informe
    doc.setFontSize(7.5);
    doc.setFontStyle('normal');
    textRel(safe(data.reference), 0.0475, L.refY);

    // =====================================================
    // BLOQUE ÁREA / CLIENTE (dentro del rectángulo gris)
    // =====================================================

    // Títulos
    doc.setFontSize(3);
    doc.setFontStyle('bold');
    textRel('Área de reparación', 0.07, L.areaTitleY);
    textRel('Cliente', 0.51, L.areaTitleY);

    // Datos área de reparación
    doc.setFontStyle('normal');
    doc.setFontSize(3);

    let yArea = h * L.areaDataStartY;
    const xArea = w * 0.07;
    const stepArea = h * 0.0125;

    // Valores por defecto (por si falta algo en Firestore)
    const defaultArea = {
        companyName: 'NOMBRE EMPRESA',
        taxId: 'CIF EMPRESA',
        address: 'CALLE Y PORTAL',
        postalCode: 'CODIGO POSTAL',
        city: 'LOCALIDAD',
        province: 'PROVINCIA',
        email: 'CORREO ELECTRÓNICO',
        phone: 'Nº TELÉFONO',
    };

    const s = { ...defaultArea, ...(appSettings || {}) };

    const drawCompanyFooter = () => {
        const xLeft = w * 0.0475;
        const boxWidth = w * L.footerWidth;

        doc.setTextColor(120, 120, 120);

        // --------------------------------------------------
        // Helper generico con autoajuste e Y fija
        // --------------------------------------------------
        const drawFooterBlock = (
            text,
            yRel,
            boxHeightMm,
            fontSizeMax = 3,
            paddingTopMm = 0,
            lineHeightFactor = 0.6
        ) => {
            if (!text) return;

            const yTop = h * yRel + paddingTopMm;

            let fontSize = fontSizeMax;
            const minFontSize = 1.1;
            let lines = [];

            while (fontSize >= minFontSize) {
                doc.setFontSize(fontSize);
                lines = doc.splitTextToSize(text, boxWidth);

                const lineHeight = fontSize * lineHeightFactor;
                const totalHeight = lines.length * lineHeight;

                if (totalHeight <= boxHeightMm) break;

                fontSize -= 0.1;
            }

            const lineHeight = fontSize * lineHeightFactor;
            const startY = yTop;

            lines.forEach((line, i) => {
                doc.text(
                    line,
                    xLeft,
                    startY + i * lineHeight,
                    {
                        maxWidth: boxWidth,
                        align: "justify"
                    }
                );
            });
        };

        // --------------------------------------------------
        // BLOQUE 1 — TEXTO CALIDAD DEL SERVICIO
        // --------------------------------------------------
        const qualityText = (appSettings?.serviceQualityText || '').trim();

        if (qualityText) {
            drawFooterBlock(
                qualityText,
                L.footerBlock1Y,
                4,
                3.5,
                0,
                0.45
            );
        }

        // --------------------------------------------------
        // BLOQUE 2 — DATOS EMPRESA (siempre igual)
        // --------------------------------------------------
        const block2Text =
            `${safe(s.companyName)} | ${safe(s.taxId)} | ${safe(s.address)} ` +
            `${safe(s.postalCode)} ${safe(s.city)} (${safe(s.province)})`;

        drawFooterBlock(
            block2Text,
            L.footerBlock2Y,
            1.6,
            3,
            0,
            0.6
        );

        // --------------------------------------------------
        // BLOQUE 3 — REGISTRO MERCANTIL
        // --------------------------------------------------
        const rmProvince = (appSettings?.province || s.province || '').trim();
        const mercantileBook = (appSettings?.mercantileBook || '').trim();
        const mercantilePage = (appSettings?.mercantilePage || '').trim();
        const mercantileSheet = (appSettings?.mercantileSheet || '').trim();

        const regParts = [];
        if (mercantileBook) regParts.push(`Tomo ${mercantileBook}`);
        if (mercantilePage) regParts.push(`Folio ${mercantilePage}`);
        if (mercantileSheet) regParts.push(`Hoja ${mercantileSheet}`);

        let block3Text = "";

        if (rmProvince || regParts.length) {
            const prefix = rmProvince
                ? `Inscrita en el R.M. de ${rmProvince}.`
                : `Inscrita en el Registro Mercantil.`;

            const regStr = regParts.join(', ');

            block3Text = regStr ? `${prefix} ${regStr}` : prefix;
        }

        if (block3Text) {
            drawFooterBlock(
                block3Text,
                L.footerBlock3Y,
                1.6,
                3,
                0,
                0.6
            );
        }

        // Reset color para el resto del documento
        doc.setTextColor(0, 0, 0);
    };

    const lines = [
        safe(s.companyName),
        safe(s.taxId),
        safe(s.address),
        `${safe(s.postalCode)} ${safe(s.city)}, ${safe(s.province)}`,
        safe(s.email),
        safe(s.phone),
    ].filter(Boolean);

    lines.forEach(line => {
        doc.text(line, xArea, yArea);
        yArea += stepArea;
    });

    // Datos cliente
    doc.setFontStyle('normal');
    doc.setFontSize(3);

    let yClient = h * L.clientStartY;
    const xClient = w * 0.51;
    const stepClient = h * 0.0125;

    doc.text(safe(clientData.name), xClient, yClient); yClient += stepClient;
    doc.text(safe(clientData.id), xClient, yClient); yClient += stepClient;
    doc.text(safe(clientData.street), xClient, yClient); yClient += stepClient;

    const fullAddress = `${safe(clientData.postcode)} ${safe(clientData.locality)} ${safe(clientData.community)}`.trim();
    doc.text(fullAddress, xClient, yClient); yClient += stepClient;
    doc.text(safe(clientData.mail), xClient, yClient); yClient += stepClient;
    doc.text(safe(clientData.phone), xClient, yClient);

    // Fecha recepción
    doc.setFontSize(3);
    doc.setFontStyle('bold');
    textRel('Fecha de recepción', 0.07, L.fechaLabelY);
    doc.setFontStyle('normal');
    doc.setFontSize(3);
    textRel(
        data.dateEntry ? renderDate(data.dateEntry) : '',
        0.07,
        L.fechaValueY
    );

    // =====================================================
    // DATOS DEL EQUIPO
    // =====================================================

    doc.setFontSize(4);
    doc.setFontStyle('normal');
    textRel('Datos del equipo', 0.0475, L.equipoTitleY);

    // Cabecera columnas
    doc.setFontSize(3);
    doc.setFontStyle('bold');
    const yEquipHeader = h * L.equipoHeaderY;
    const xSerie = w * 0.0475;
    const xDevice = w * 0.325;
    const xRefClient = w * 0.69;

    doc.text('Número de serie/IMEI', xSerie, yEquipHeader);
    doc.text('Dispositivo', xDevice, yEquipHeader);
    doc.text('Ref. cliente', xRefClient, yEquipHeader);

    // Valores
    doc.setFontStyle('normal');
    doc.setFontSize(2.5);

    let yEquipVal = yEquipHeader + 2;

    // Campo IMEI/Serial: si contiene espacio, dividir en dos líneas
    if (data.imei) {
        const value = safe(data.imei);

        if (value.includes(" ")) {
            const [first, ...rest] = value.split(" ");
            const second = rest.join(" ");

            doc.text(first, xSerie, yEquipVal);
            yEquipVal += 1.5; // salto
            doc.text(second, xSerie, yEquipVal);
            yEquipVal += 1.5 // separación final
        } else {
            doc.text(value, xSerie, yEquipVal);
            yEquipVal += 3;
        }
    }

    const deviceName = safe(data.deviceName);
    doc.text(deviceName, xDevice, yEquipHeader + 2, {
        maxWidth: w * 0.32
    });

    const clientRef = safe(data.clientRef || data.refClient);
    doc.text(clientRef, xRefClient, yEquipHeader + 2);

    // =====================================================
    // DATOS DE LA AVERÍA (Síntoma)
    // =====================================================

    doc.setFontSize(4);
    doc.setFontStyle('normal');
    textRel('Datos de la avería', 0.0475, L.averiaTitleY);

    doc.setFontSize(3);
    doc.setFontStyle('bold');
    const ySymptomHeader = h * L.symptomLabelY;
    doc.text('Síntoma', w * 0.0475, ySymptomHeader);

    const symptomMessages = detailData.failures || [];
    const symptomText = buildMessages(symptomMessages, false) || safe(data.symptom);

    doc.setFontStyle('normal');
    doc.setFontSize(2.5);
    doc.text(symptomText, w * 0.0475, ySymptomHeader + 2, {
        maxWidth: w * 0.86
    });

    // =====================================================
    // DATOS DE LA REPARACIÓN
    // =====================================================

    doc.setFontSize(4);
    doc.setFontStyle('normal');
    textRel('Datos de la reparación', 0.0475, L.reparacionTitleY);

    const yRepairHeader = h * L.reparacionHeaderY;
    const xDiag = w * 0.0475;
    const xRes = w * 0.5;

    doc.setFontSize(3);
    doc.setFontStyle('bold');
    doc.text('Diagnóstico', xDiag, yRepairHeader);
    doc.text('Resolución', xRes, yRepairHeader);

    // Diagnóstico:
    // 1) Intentamos coger estimationWork (diagnóstico detallado)
    // 2) Si está vacío, usamos la AVERÍA de la tarea → data.description
    let diagText = buildMessages(detailData.works || [], false);
    if (!diagText) {
        diagText = safe(data.description || '');
    }

    // Resolución: Trabajo realizado
    const resText = buildMessages(detailData.estimationWork || [], false);

    doc.setFontStyle('normal');
    doc.setFontSize(2.5);

    const yRepairText = yRepairHeader + 2;

    doc.text(diagText, xDiag, yRepairText, {
        maxWidth: w * 0.38
    });
    doc.text(resText, xRes, yRepairText, {
        maxWidth: w * 0.38
    });

    // =====================================================
    // DESGLOSE + IMPORTES
    // =====================================================

    doc.setFontSize(4);
    doc.setFontStyle('normal');
    textRel('Desglose de piezas y servicios', 0.0475, L.desgloseTitleY);

    // Cálculos — usa los % guardados en detailData o 70/30 por defecto
    const refillRaw   = detailData.refill   != null ? Number(detailData.refill)   : 70;
    const manPowerRaw = detailData.manPower != null ? Number(detailData.manPower) : 30;
    const refillPercent   = refillRaw   / 100;
    const manPowerPercent = manPowerRaw / 100;

    const ivaPercent = 0.21;
    const budget = parseFloat(data.budget || 0) || 0;
    const ivaIncluded = data.iva !== false;

    // Base imponible, IVA y total según si el presupuesto lleva IVA incluido o no
    const budgetWithoutIvaNumber = ivaIncluded
        ? budget / (1 + ivaPercent)   // extraemos la base
        : budget;                      // el budget ES la base
    const ivaPriceNumber = ivaIncluded
        ? budget - budgetWithoutIvaNumber
        : budget * ivaPercent;
    const totalPrice = ivaIncluded ? budget : budget + ivaPriceNumber;

    // Desglose sin IVA por línea
    const refillPriceNumber = budgetWithoutIvaNumber * refillPercent;
    const manPowerPriceNumber = budgetWithoutIvaNumber * manPowerPercent;

    // Valores formateados para el pie
    const budgetPrice = budget ? totalPrice.toFixed(2) : '';
    const subtotalPrice = budget ? budgetWithoutIvaNumber.toFixed(2) : '';
    const ivaPrice = budget ? ivaPriceNumber.toFixed(2) : '';

    // Texto central en la banda gris
    if (budget) {
        doc.setFontSize(4);
        doc.setFontStyle('normal');
        const ivaLabel = ivaIncluded ? '(IVA incluido)' : '(IVA no incluido en presupuesto)';
        const totalText = `El importe total de la reparación es de ${budgetPrice}€ ${ivaLabel}`;
        doc.text(totalText, w / 2, h * L.importeTextoY, { align: 'center' });
    }

    // Cabecera tabla
    doc.setFontSize(3);
    doc.setFontStyle('bold');
    const yTableHeader = h * L.tablaHeaderY;

    const xDesc = w * 0.06;
    const xUds = w * 0.57;
    const xPriceUd = w * 0.67;
    const xSubtotal = w * 0.84;
    const xTotal = w * 0.94;


    doc.text('Descripción', xDesc, yTableHeader);
    doc.text('Uds.', xUds, yTableHeader, { align: 'right' });
    doc.text('Precio/ud.', xPriceUd, yTableHeader, { align: 'right' });
    doc.text('Subtotal', xSubtotal, yTableHeader, { align: 'right' });
    doc.text('Total', xTotal, yTableHeader, { align: 'right' });

    // ======== LÍNEAS DE DETALLE: RECAMBIOS / MANO DE OBRA =========
    doc.setFontStyle('normal');
    doc.setFontSize(3);

    let yRow = yTableHeader + 3;

    // Solo pintamos si hay presupuesto sin IVA calculado
    if (budgetWithoutIvaNumber) {
        // --------- RECAMBIOS -----------
        const refillLabel = 'Recambios';
        const refillBase = refillPriceNumber;                    // sin IVA
        const refillBaseStr = refillBase.toFixed(2);
        const refillTotalWithIva = (refillBase * (1 + ivaPercent)).toFixed(2);

        doc.text(refillLabel, xDesc, yRow);
        doc.text('1', xUds, yRow, { align: 'right' });      // Uds = 1
        doc.text(`${refillBaseStr} €`, xPriceUd, yRow, { align: 'right' });  // precio/ud = sin IVA
        doc.text(`${refillBaseStr} €`, xSubtotal, yRow, { align: 'right' });  // subtotal = 1 * precio/ud
        doc.text(`${refillTotalWithIva} €`, xTotal, yRow, { align: 'right' }); // total = con IVA

        yRow += 1.75;

        // --------- MANO DE OBRA -----------
        const manPowerLabel = 'Mano de obra';
        const manPowerBase = manPowerPriceNumber;                     // sin IVA
        const manPowerBaseStr = manPowerBase.toFixed(2);
        const manPowerTotalWithIva = (manPowerBase * (1 + ivaPercent)).toFixed(2);

        doc.text(manPowerLabel, xDesc, yRow);
        doc.text('1', xUds, yRow, { align: 'right' });       // Uds = 1
        doc.text(`${manPowerBaseStr} €`, xPriceUd, yRow, { align: 'right' });   // sin IVA
        doc.text(`${manPowerBaseStr} €`, xSubtotal, yRow, { align: 'right' });   // sin IVA
        doc.text(`${manPowerTotalWithIva} €`, xTotal, yRow, { align: 'right' }); // con IVA

        yRow += 4;
    }


    // Subtotal / IVA / Total (banda inferior gris)
    const labelX = w * 0.055;
    const valueRightX = w * 0.94;

    const ySubtotal = h * L.subtotalY;
    const yIva = h * L.ivaY;
    const yTotal = h * L.totalY;

    // SUBTOTAL
    doc.setFontSize(3);
    doc.setFontStyle('normal');
    doc.text('Subtotal', labelX, ySubtotal);
    doc.text(`${subtotalPrice} €`, valueRightX, ySubtotal, { align: 'right' });

    // IVA
    doc.text('IVA (21%)', labelX, yIva);
    doc.text(`${ivaPrice} €`, valueRightX, yIva, { align: 'right' });

    // TOTAL — título + valor en negrita y tamaño 4
    doc.setFontStyle('normal');
    doc.setFontSize(4);
    doc.text('Total (IVA incluido)', labelX, yTotal);
    doc.setFontStyle('bold');
    doc.text(`${budgetPrice} €`, valueRightX, yTotal, { align: 'right' });
    doc.setFontStyle('normal');

    // PIE DE PÁGINA (Página 1)
    drawFooter(doc, w, h, appSettings);
    drawCompanyFooter();


    // =====================================================
    // FIRMA DEL CLIENTE — CUADRO PEQUEÑO ABAJO A LA DERECHA
    // =====================================================

    if (sign1) {
        // Dimensiones del cuadro de firma (mm)
        const boxW = 15;
        const boxH = 6;

        // Posición del cuadro de firma
        const xBox = w * L.signatureBoxX;  // margen derecho
        const yBox = h * L.signatureBoxY;   // margen inferior

        // --- FONDO DEL CUADRO (color #ededed) ---
        doc.setFillColor(237, 237, 237); // #ededed
        doc.rect(xBox, yBox, boxW, boxH, "F"); // "F" = filled


        // Texto legal
        const texto =
            "El cliente, mediante su firma, valida el presupuesto y autoriza la ejecución del servicio";

        // --- Config texto ---
        const padding = 0.5;
        const textFontSize = 1.5;
        doc.setFontSize(textFontSize);

        const textMaxWidth = boxW - padding * 2;
        const lines = doc.splitTextToSize(texto, textMaxWidth);
        const lineHeight = textFontSize * 0.6;   // altura por línea
        const totalTextHeight = lines.length * lineHeight;

        // Y base del texto pegado al borde inferior del cuadro
        const textBottomY = yBox + boxH - padding;

        // Primera línea (alineamos de abajo hacia arriba)
        const textStartY = textBottomY - (lines.length - 1) * lineHeight;

        // Pintar texto (centrado horizontal dentro del cuadro, con pequeño offset ajustable)
        lines.forEach((line, i) => {
            const fontSize = textFontSize;
            const scaleFactor = doc.internal.scaleFactor;

            // Ancho aproximado de la línea en unidades del documento (mm)
            const textWidth =
                doc.getStringUnitWidth(line) * fontSize / scaleFactor;

            // Centro teórico de la caja + offset fino configurable en L
            const centerX = xBox + boxW / 2 + L.signatureTextOffsetX;

            // X de inicio para que el texto quede centrado alrededor de centerX
            const xText = centerX - textWidth / 2;

            doc.text(
                line,
                xText,
                textStartY + i * lineHeight
            );
        });

        // --- Zona de firma: desde el borde superior hasta justo encima del texto ---
        const signatureTopY = yBox + padding;
        const signatureBottomY = textStartY - padding;
        const signatureHeight = Math.max(signatureBottomY - signatureTopY, 2); // mínimo 2mm

        const signatureMaxW = boxW - padding * 2;
        const signatureMaxH = signatureHeight;

        // Cargar imagen de firma
        const firmaImg = new Image();
        firmaImg.src = sign1;

        await new Promise(res => {
            firmaImg.onload = res;
        });

        // Convertir px → mm
        const pxToMm = px => px * 0.264583;
        const fw = pxToMm(firmaImg.width);
        const fh = pxToMm(firmaImg.height);

        const scale = Math.min(signatureMaxW / fw, signatureMaxH / fh);
        const finalW = fw * scale;
        const finalH = fh * scale;

        // Centrar firma dentro de su zona
        const xFirma = xBox + (boxW - finalW) / 2;
        const yFirma = signatureTopY + (signatureHeight - finalH) / 2;

        doc.addImage(
            firmaImg,
            'PNG',
            xFirma,
            yFirma,
            finalW,
            finalH,
            '',
            'FAST'
        );
    }

    // =====================================================
    // PÁGINA 2 (y siguientes): FOTOS
    // =====================================================

    if (!detailData?.images || detailData.images.length === 0) {
        drawCompanyFooter();
        addPagination(doc);   // paginación
        return;
    }

    // Helper para preparar una página de fotos
    const preparePhotoPage = () => {
        doc.addPage();

        // Fondo plantilla de fotos
        const bg2 = new Image();
        bg2.src = pdf_2;
        doc.addImage(bg2, 'PNG', 0, 0, w, h, '', 'FAST');

        // CABECERA: "Informe fotográfico" + número de informe
        doc.setFontSize(4);
        doc.setFontStyle('normal');
        textRel('Informe fotográfico', 0.0475, L.titleY);

        doc.setFontSize(7.5);
        doc.setFontStyle('normal');
        textRel(safe(data.reference), 0.0475, L.refY);

        // PIE DE PÁGINA
        drawFooter(doc, w, h, appSettings);
        drawCompanyFooter();
    };

    // Primera página de fotos
    preparePhotoPage();

    const images = detailData.images;
    let index = 0;

    for (let img of images) {
        if (index === 0) {
            await addImage(doc, img, w * 0.05, h * L.photosRow1Y);
            index++;
        } else if (index === 1) {
            await addImage(doc, img, w * 0.55, h * L.photosRow1Y);
            index++;
        } else if (index === 2) {
            await addImage(doc, img, w * 0.05, h * L.photosRow2Y);
            index++;
        } else if (index === 3) {
            await addImage(doc, img, w * 0.55, h * L.photosRow2Y);
            index++;
            if (images[index]) {
                index = 0;
                preparePhotoPage();
            }
        }
    }
    addPagination(doc);
};

// =============== HELPERS ===============

const addImage = (doc, img, x, y) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.src = img.url;
        image.onload = function () {
            // Tamaño de la página
            const pageW = doc.internal.pageSize.getWidth();
            const pageH = doc.internal.pageSize.getHeight();

            // HUECO FIJO IMAGENES
            const boxW = pageW * 0.40;
            const boxH = pageH * 0.35;

            // Tamaño real de la imagen (en píxeles)
            const imgW = image.width;
            const imgH = image.height;

            // Escala manteniendo proporción para encajar DENTRO del hueco
            const scale = Math.min(boxW / imgW, boxH / imgH);

            const finalW = imgW * scale;
            const finalH = imgH * scale;

            // Centramos dentro del hueco cuyo origen es (x, y)
            const offsetX = x + (boxW - finalW) / 2;
            const offsetY = y + (boxH - finalH) / 2;

            doc.addImage(
                image,
                'JPEG',
                offsetX,
                offsetY,
                finalW,
                finalH,
                '',
                'FAST'
            );

            resolve();
        };
        image.onerror = reject;
    });
};

const buildMessages = (messages, flagDate = true) => {
    const list = messages || [];
    return list
        .filter(m => m && m.message)
        .map(m =>
            flagDate && m.date ? `${m.message} (${renderDate(m.date)})` : m.message
        )
        .join(' ');
};

export default createPDFSignUseCase;